var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('articles',[_c('banner')],1),_c('about'),_c('subscribe'),_c('social')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }